import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthShell } from "@/components/auth/AuthShell";
import { useAppAuth } from "@/components/auth/AuthProvider";
import { getAuthErrorMessage } from "@/components/auth/auth-helpers";
import styles from "@/components/auth/AuthForm.module.scss";

export function ForgotPasswordPage() {
  const { isLoaded, startPasswordReset } = useAppAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);
    try {
      await startPasswordReset(email);
      setNotice("If that account exists, a password reset email is on its way.");
    } catch (submitError) {
      setError(getAuthErrorMessage(submitError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell mode="forgot-password">
      <div className={styles.stack}>
        {notice ? <p className={styles.notice}>{notice}</p> : null}
        {error ? <p className={styles.error}>{error}</p> : null}
        <form className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.field}>
            <span className={styles.label}>Email</span>
            <input
              className={styles.input}
              type="email"
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              disabled={!isLoaded || isSubmitting}
              required
            />
          </label>
          <button className={styles.submit} type="submit" disabled={!isLoaded || isSubmitting}>
            {isSubmitting ? <Loader2 size={20} className={styles.spinIcon} /> : "Send reset email"}
          </button>
        </form>
        <div className={styles.linkRow}>
          <Link className={styles.link} to="/login">Back to sign in</Link>
        </div>
      </div>
    </AuthShell>
  );
}
